import axios from 'axios';

const instance = axios.create({
	baseURL: 'https://api.mzk.bydgoszcz.pl',
});

instance.interceptors.request.use((config) => {
	const token = localStorage.getItem('token');
	if (token) {
		config.headers['X-Auth'] = token;
	}
	return config;
});

export default instance;
